<snelstart-ui-button (click)="this.showDialog()"
                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg"
                                title="Specificatie fiscale oudedagsreserve">
    <snelstart-ui-dialog-body>

        <div *ngIf="this.getForEindstand().valueOf() > this.getForBeginstand().valueOf()" class="row col-5 pb-2">
            <snelstart-ui-alert class="pt-3" type="danger">
                Het bedrag volgens de slotbalans (€{{ this.getForEindstand().valueOf() | number:'1.0-0' }}) is hoger
                dan het bedrag van de openingsbalans (€{{ this.getForBeginstand().valueOf() | number:'1.0-0' }}). Klopt
                dat wel? Je mag namelijk sinds het jaar 2023 geen bedragen meer toevoegen aan een per 31 december 2022 (bestaande)
                FOR.
            </snelstart-ui-alert>
        </div>

        <div class="ps-2">
            <form [formGroup]="specFORFG">
                    <div class="row">
                        <div class="col col-1">
                            <p>Bedrag volgens openingsbalans</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [disabledControl]="true"
                                                              align="right"
                                                              class="col-auto custom-input-150"
                                                              formControlName="waardeOpening"
                                                              prefix="€"

                            >
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>
            </form>

            <form [formGroup]="ondernemingFG">
                <div formArrayName="ondernemingen">
                    <div *ngFor="let onderneming of ondernemingen.controls; let i = index "
                                  [formGroupName]="i">
                            <div class="row">
                                <div class="col col-1">
                                    <p>Af: Onttrekking ten gunste van resultaat</p>
                                </div>
                                <div class="col-2">
                                    <snelstart-ui-number-form-control (change)="saveForm()"
                                                                      [decimals]="0"

                                                                      align="right"
                                                                      class="col-auto custom-input-150"
                                                                      formControlName="vrijvalFOR"
                                                                      id="vrijvalFOR"
                                                                      prefix="€ -"

                                    >
                                    </snelstart-ui-number-form-control>
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                            </div>
                        </div>
                    </div>
            </form>
            <form [formGroup]="specFORFG">
                    <div class="row">
                        <div class="col col-1">
                            <p>Bedrag volgens slotbalans</p>
                        </div>
                        <div class="col-2">
                            <snelstart-ui-number-form-control (change)="saveForm()"
                                                              [decimals]="0"
                                                              [disabledControl]="true"
                                                              align="right"
                                                              align="right"
                                                              class="col-auto custom-input-150 "
                                                              formControlName="waardeSlot"
                                                              prefix="€"

                            >
                            </snelstart-ui-number-form-control>
                        </div>
                        <div class="col-4"></div>
                        <div class="col-4"></div>
                    </div>
                <div *ngIf="this.getTotaal() !== 0" class="row col-5 ">
                    <snelstart-ui-alert class="pt-3 pb-3" type="info">
                        Een bedrag van € {{ this.getTotaal().valueOf() | number:'1.0-0' }} is nog niet gespecificeerd.
                    </snelstart-ui-alert>
                </div>
            </form>
        </div>

    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button (click)=saveForm() icon="check" id="save2" type="primary">
            Akkoord
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>

<div *ngIf="!heeftOndernemingen()">
    <div *ngIf="!partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamAangever }} ingevuld.
    </div>

    <div *ngIf="partnerBoolean">
        Er is geen onderneming voor {{ this.dataService.naamPartner }} ingevuld.
    </div>
</div>
